import {MAIN_ROUTER_LIST, PAI_POINT_AUTH, ROUTER_PATH_ADMIN} from "utils/constants";
import {AdminSiderMenuItem} from "./interface";
import {Store} from "utils/mobx";

export const getToken = () => {
    const userInfo: string = localStorage.getItem(PAI_POINT_AUTH) || ''
    return userInfo;
}

export const clearAuthToken = () => {
    localStorage.removeItem(PAI_POINT_AUTH)
}

export const isNeedGoToLogin = (url: string) => {
    const token = getToken()
    const urlList = url.split('/')
    if (urlList.length > 2) {
        urlList.splice(1, 1)
        const appUrl = urlList.join('/')
        if (!token) {
            return !MAIN_ROUTER_LIST.includes(appUrl)
        }
    }
    return false
}

export const checkIsAdminPage = (url: string, businessId: string) => {
    const replaceStr = businessId ? `/${businessId}` : ''
    const resultUrl = url.replace(replaceStr, "");
    return ROUTER_PATH_ADMIN.indexOf(resultUrl) > -1;
}


export const processMenuItems = (data: AdminSiderMenuItem[], id: string | number) => {
    const items: any[] = []
    const parentIds: string[] = []
    let children: any = {}
    if (data.length > 0) {
        const sortMenuConfig = data.sort((a: any, b: any) => Number(a.parentId || 0) - Number(b?.parentId || 0))
        sortMenuConfig.forEach((v: AdminSiderMenuItem, index: number) => {
            if (v.parentId === `${id}`) {
                const item = {
                    id: `${v?.id}`,
                    label: v?.applicationName,
                    url: v?.url || '',
                    key: `${v?.id}`,
                    onClick: (value: any) => {
                        Store.RouterStore.setRouterPath({...v, ...value, index})
                    }
                }
                items.push(item)
            } else {
                if (id === 0 || id === "0") {
                    if (children[v?.parentId]) {
                        parentIds.push(v?.parentId)
                        children = {
                            ...children,
                            [v?.parentId]: [
                                ...children[v?.parentId],
                                v
                            ]
                        }
                    } else {
                        children = {
                            ...children,
                            [v?.parentId]: [v]
                        }
                        if (v?.parentId && parentIds.indexOf(v?.parentId) < 0) {
                            const fatherItems = sortMenuConfig.filter(vs => vs?.id === v?.parentId)
                            if (fatherItems.length > 0) {
                                parentIds.push(v?.parentId)
                            }
                        }
                    }
                }
            }
        })
    }

    if (parentIds.length > 0) {
        parentIds.forEach((v: string) => {
            const childrenItems = processMenuItems(children[v], v)
            const fatherIndex: number = items.findIndex((fatherItem) => fatherItem?.id === v)
            const newItem = {
                ...items[fatherIndex],
                children: childrenItems
            }
            items.splice(fatherIndex, 1, newItem)
        })
    }
    return items
}

export const urlSearchToString = (req?: any) => {
    if (req) {
        let search: string = ''
        const keys = Object.keys(req)
        keys.forEach((v) => {
            if (req[v]) {
                search = search + `${search === '' && "?"}${v}=${req[v]}`
            }
        })
        return search
    }
    return ''
}